import { Route, Switch } from 'wouter';
import { useAuth } from './lib/auth';
import { Login } from './screens/Login';
import { Dashboard } from './screens/Dashboard';
import { ProjectDetail } from './screens/ProjectDetail';
import { ProjectConfig } from './screens/ProjectConfig';
import { ServerConfig } from './screens/ServerConfig';
import { Settings } from './screens/Settings';
import { NewSession } from './screens/NewSession';
import { Console } from './screens/Console';
import { Usage } from './screens/Usage';

export function App() {
  const { authed, loading } = useAuth();
  if (loading) {
    return <div className="center muted">…</div>;
  }
  if (!authed) {
    return <Login />;
  }
  return (
    <Switch>
      <Route path="/">{() => <Dashboard />}</Route>
      <Route path="/server">{() => <Dashboard initialTab="server" />}</Route>
      <Route path="/notifiche">{() => <Dashboard initialTab="notifiche" />}</Route>
      <Route path="/p/:id/config">{(params) => <ProjectConfig id={params.id} />}</Route>
      <Route path="/server/:id/config">{(params) => <ServerConfig id={params.id} />}</Route>
      <Route path="/p/:id/new">{(params) => <NewSession key={params.id} projectId={params.id} />}</Route>
      <Route path="/p/:id">{(params) => <ProjectDetail id={params.id} />}</Route>
      <Route path="/settings" component={Settings} />
      <Route path="/usage" component={Usage} />
      <Route path="/new">{() => <NewSession />}</Route>
      <Route path="/s/:id">{(params) => <Console id={params.id} />}</Route>
      <Route><Dashboard /></Route>
    </Switch>
  );
}
